import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface ContentBadgeProps extends Omit<BoxProps, 'sx'> {
  children: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
}

export function ContentBadge({ children, icon, sx, ...props }: ContentBadgeProps) {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        padding: '4px 8px',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '6px',
        border: '1px solid #AF52DE',
        background: '#FDEDFF',
        ...sx,
      }}
      {...props}
    >
      {icon}
      <Box
        component="span"
        sx={{
          color: '#AF52DE',
          fontSize: 12,
          fontFamily: 'Inter',
          fontWeight: 600,
          lineHeight: '20px',
          letterSpacing: '-0.072px',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
